import { mix } from "@chorda/core";
import { Delete } from "../elements";
export const Message = (props) => {
    return mix({
        tag: 'article',
        css: 'message',
        templates: {
            header: {
                weight: -10,
                css: 'message-header',
                templates: {
                    title: {
                        tag: 'p'
                    },
                    close: Delete
                }
            },
            body: {
                css: 'message-body'
            }
        }
    }, props && {
        components: {
            body: {
                components: {
                    content: props.content
                },
                html: props.html
            },
            header: props.header == null ? true : props.header
        },
        templates: {
            header: {
                components: {
                    title: {
                        text: props.title
                    },
                    close: {
                        events: {
                            click: props.onClose
                        }
                    }
                }
            }
        }
    });
};
